document.addEventListener("DOMContentLoaded", () => {
  const filterForm = document.querySelector("#filterContainer form") || document.querySelector("form");
  const sortBySelect = document.getElementById("sort-by");
  const productGridContainer = document.getElementById("product-grid-container");
  const collectionsFilterGrid = document.getElementById("collections-filter-grid");
  const filterType = document.querySelector("#filter-type")?.textContent.trim();
  let clearButton = document.getElementById("clearButton");
  const appliedFiltersDiv = document.querySelector(".applied-filters");

  if (!filterForm || !productGridContainer || !collectionsFilterGrid) return;

  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  const collectionHandle = collectionsFilterGrid.getAttribute("data-collection-handle");
  const langPrefixMatch = currentPath.match(/^\/[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\//);
  const langPrefix = langPrefixMatch ? langPrefixMatch[0] : "/";
  let baseUrl = `${langPrefix}collections/${collectionHandle}`;
  const urlParams = new URLSearchParams(currentSearch);
  const currencyParam = urlParams.get("currency");

  const loadSvgIcon = (iconName, container) => {
    const TuT = iconName.toLowerCase().trim();
    const loadingIndicator = document.createElement("span");
    loadingIndicator.classList.add("loading-indicator");
    container.appendChild(loadingIndicator);

    fetch(`//glenthemes.github.io/iconsax/icons/${TuT}.svg`)
      .then(res => res.text())
      .then(svg => {
        container.innerHTML = svg;
        loadingIndicator.remove();
      })
      .catch(err => {
        console.error(`Error loading SVG: ${iconName}`, err);
        loadingIndicator.remove();
      });
  };

  const normalizePriceValue = (value) => {
    return Number(value).toFixed(2).replace(/\.00$/, "");
  };

  const getActiveCurrencyCode = () => {
    const currencyLabel = document.querySelector(".currency-selector .selector-link span");
    const visibleCurrencyCode = currencyLabel ? currencyLabel.textContent.trim() : "";

    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }

    if (/^[A-Z]{3}$/.test(visibleCurrencyCode)) {
      return visibleCurrencyCode;
    }

    return currencyParam || "INR";
  };

  const formatPriceFilterValue = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return "";

    const hasFraction = Math.abs(numericValue % 1) > 0.0001;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency: getActiveCurrencyCode(),
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: hasFraction ? 2 : 0
      }).format(numericValue);
    } catch (error) {
      return `${getActiveCurrencyCode()} ${normalizePriceValue(numericValue)}`;
    }
  };

  const syncFallbackPriceAppliedFilter = () => {
    const appliedFilterList = appliedFiltersDiv ? appliedFiltersDiv.querySelector(".apply-filter-list") : null;
    if (!appliedFilterList) return;

    appliedFilterList.querySelectorAll("[data-fallback-price-filter]").forEach((item) => item.remove());

    const hasNativePriceFilter = Array.from(appliedFilterList.querySelectorAll("a[data-filter-price]"))
      .some((item) => !item.hasAttribute("data-fallback-price-filter"));

    if (hasNativePriceFilter) return;

    const minInput = document.getElementById("Filter-filter.v.price.gte");
    const maxInput = document.getElementById("Filter-filter.v.price.lte");
    const priceSlider = document.querySelector('.price-slider[data-param-name-max="filter.v.price.lte"]');

    if (!priceSlider || (!minInput && !maxInput)) return;

    const sliderMin = parseFloat(priceSlider.dataset.min || "0");
    const sliderMax = parseFloat(priceSlider.dataset.max);
    const activeMin = minInput && minInput.value !== "" ? parseFloat(minInput.value) : sliderMin;
    const activeMax = maxInput && maxInput.value !== "" ? parseFloat(maxInput.value) : sliderMax;
    const hasMin = minInput && minInput.value !== "" && Number.isFinite(activeMin) && activeMin > sliderMin;
    const hasMax = maxInput && maxInput.value !== "" && Number.isFinite(activeMax) && activeMax < sliderMax;

    if (!hasMin && !hasMax) return;

    const priceFilterLink = document.createElement("a");
    priceFilterLink.href = "#";
    priceFilterLink.className = "center";
    priceFilterLink.setAttribute("data-filter-price", "Filter-filter.v.price.gte?Filter-filter.v.price.lte");
    priceFilterLink.setAttribute("data-fallback-price-filter", "true");
    priceFilterLink.append(`${formatPriceFilterValue(hasMin ? activeMin : sliderMin)} - ${formatPriceFilterValue(hasMax ? activeMax : sliderMax)} `);

    const removeMarker = document.createElement("span");
    removeMarker.setAttribute("aria-hidden", "true");
    removeMarker.textContent = "x";
    priceFilterLink.appendChild(removeMarker);

    const clearButtonEl = appliedFilterList.querySelector("#clearButton");
    if (clearButtonEl) {
      appliedFilterList.insertBefore(priceFilterLink, clearButtonEl);
    } else {
      appliedFilterList.appendChild(priceFilterLink);
    }
  };

  const applyClientSidePriceFilter = () => {
    if (!productGridContainer) return;

    const minInput = document.getElementById("Filter-filter.v.price.gte");
    const maxInput = document.getElementById("Filter-filter.v.price.lte");
    const searchParams = new URLSearchParams(window.location.search);
    const activeMin = minInput && minInput.value !== "" ? parseFloat(minInput.value) : parseFloat(searchParams.get("filter.v.price.gte"));
    const activeMax = maxInput && maxInput.value !== "" ? parseFloat(maxInput.value) : parseFloat(searchParams.get("filter.v.price.lte"));
    const hasMin = Number.isFinite(activeMin);
    const hasMax = Number.isFinite(activeMax);
    const productItems = productGridContainer.querySelectorAll(".product-item");
    let visibleCount = 0;

    productItems.forEach((item) => {
      const productBox = item.querySelector(".product-box");
      const productPrice = productBox ? parseFloat(productBox.dataset.productPrice) : NaN;
      const matchesMin = !hasMin || (Number.isFinite(productPrice) && productPrice >= activeMin);
      const matchesMax = !hasMax || (Number.isFinite(productPrice) && productPrice <= activeMax);
      const shouldShow = matchesMin && matchesMax;

      item.style.display = shouldShow ? "" : "none";

      if (shouldShow) {
        visibleCount += 1;
      }
    });

    let emptyMessage = document.getElementById("price-filter-empty-message");

    if ((hasMin || hasMax) && productItems.length > 0 && visibleCount === 0) {
      if (!emptyMessage) {
        emptyMessage = document.createElement("p");
        emptyMessage.id = "price-filter-empty-message";
        emptyMessage.className = "filter-empty-content";
        emptyMessage.textContent = "No products in this price range";
        productGridContainer.insertAdjacentElement("afterend", emptyMessage);
      }
    } else if (emptyMessage) {
      emptyMessage.remove();
    }
  };

  function bindClearAllButton() {
    clearButton = document.getElementById("clearButton");
    if (!clearButton) return;

    clearButton.addEventListener("click", e => {
      e.preventDefault();

      const inputs = filterForm.querySelectorAll(
        "input[type='checkbox'], input[type='radio'], input[type='number']"
      );
      const priceInputs = filterForm.querySelectorAll("input[data-price-filter-input]");

      inputs.forEach(input => {
        if (input.type === "number") input.value = "";
        else input.checked = false;
      });

      priceInputs.forEach((input) => {
        input.value = "";
      });

      document.querySelectorAll(".price-slider").forEach((slider) => {
        if (typeof window.$ === "undefined") return;

        const sliderInstance = $(slider).data("ionRangeSlider");
        if (!sliderInstance) return;

        sliderInstance.update({
          from: parseFloat(slider.dataset.min || "0"),
          to: parseFloat(slider.dataset.max)
        });
      });

      appliedFiltersDiv.innerHTML = "";

      let refreshUrl = baseUrl;
      if (currencyParam) {
        refreshUrl += `?currency=${currencyParam}`;
      }

      location.assign(refreshUrl);
    });
  }

  const fetchAndUpdateProducts = (queryString) => {
    let fetchUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    if (currencyParam && !fetchUrl.includes("currency=")) {
      fetchUrl += (fetchUrl.includes("?") ? "&" : "?") + `currency=${currencyParam}`;
    }

    fetch(fetchUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const updatedGrid = doc.getElementById("product-grid-container");
        if (updatedGrid) productGridContainer.innerHTML = updatedGrid.innerHTML;

        const newAppliedFilters = doc.querySelector(".applied-filters");
        appliedFiltersDiv.innerHTML = newAppliedFilters ? newAppliedFilters.innerHTML : "";
        syncFallbackPriceAppliedFilter();
        applyClientSidePriceFilter();

        history.pushState(null, "", fetchUrl);

        const icons = document.querySelectorAll(".iconsax");
        icons.forEach(icon => {
          const iconName = icon.getAttribute("icon-name");
          if (iconName) loadSvgIcon(iconName, icon);
        });

        bindClearAllButton();

        if (typeof updateWishlistButtonState === "function") updateWishlistButtonState();
      })
      .catch(err => console.error("Error fetching updated products:", err));
  };


  const serializeForm = () => {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams();

    formData.forEach((value, key) => {
      if (value !== "" && value != null) {
        params.append(key, value);
      }
    });

    return params.toString();
  };

  filterForm.addEventListener("change", () => {
    const queryString = serializeForm();
    fetchAndUpdateProducts(queryString);
  });

  if (sortBySelect) {
    sortBySelect.addEventListener("change", () => {
      const queryString = serializeForm() + `&sort_by=${sortBySelect.value}`;
      fetchAndUpdateProducts(queryString);
    });
  }

  appliedFiltersDiv.addEventListener("click", e => {
    const filterLink = e.target.closest("a");
    if (!filterLink) return;
    e.preventDefault();

    const dataFilterPrice = filterLink.getAttribute("data-filter-price");
    const filterInputId = filterLink.getAttribute("data-filter");

    if (dataFilterPrice) {
      const [minId, maxId] = dataFilterPrice.split("?");
      const minInput = document.getElementById(minId);
      const maxInput = document.getElementById(maxId);
      if (minInput) minInput.value = "";
      if (maxInput) maxInput.value = "";

      document.querySelectorAll(".price-slider").forEach((slider) => {
        const matchesMin = slider.dataset.paramNameMin === minId.replace(/^Filter-/, "");
        const matchesMax = slider.dataset.paramNameMax === maxId.replace(/^Filter-/, "");

        if (!matchesMin || !matchesMax || typeof window.$ === "undefined") return;

        const sliderInstance = $(slider).data("ionRangeSlider");
        if (!sliderInstance) return;

        sliderInstance.update({
          from: parseFloat(slider.dataset.min || "0"),
          to: parseFloat(slider.dataset.max)
        });
      });
    } else if (filterInputId) {
      const filterInput = document.getElementById(filterInputId);
      if (filterInput) filterInput.checked = false;
    }

    const queryString = serializeForm();
    fetchAndUpdateProducts(queryString);
  });


  document.querySelectorAll(".iconsax").forEach(icon => {
    const iconName = icon.getAttribute("icon-name");
    if (iconName) loadSvgIcon(iconName, icon);
  });


  bindClearAllButton();
  syncFallbackPriceAppliedFilter();
  applyClientSidePriceFilter();

  document.querySelectorAll(".iconsax").forEach(icon => {
    const iconName = icon.getAttribute("icon-name");
    if (iconName) loadSvgIcon(iconName, icon);
  });

  const gridStyleParent = document.querySelector(".filter-option-grid");
  const visibleEl = document.getElementById("product-grid-container");
  if (gridStyleParent && visibleEl) {
    let userSelectedGrid = false;
    const supportsFiveColumnGrid = filterType !== "vertical";

    const savedGrid = localStorage.getItem("selectedGrid");

    function normalizeGrid(grid) {
      if (!supportsFiveColumnGrid && grid === "5") return "4";
      return grid;
    }

        function applyGrid(grid) {
      grid = normalizeGrid(grid);
      gridStyleParent.querySelectorAll(".nav-link").forEach(el => el.classList.remove("active"));

      if (grid === "list") {
        document.querySelector(`.nav-link[data-grid="list"]`)?.classList.add("active");
        visibleEl.className = "list-view row g-4 product-list";
      } else if (grid === "1") {
        document.querySelector(`.nav-link[data-grid="1"]`)?.classList.add("active");
        visibleEl.className = "row-cols-1 row-cols-sm-2 row-cols-md-3 row g-4 product-list";
      } else if (grid === "2") {
        document.querySelector(`.nav-link[data-grid="2"]`)?.classList.add("active");
        visibleEl.className = "row-cols-2 row-cols-sm-2 row g-4 product-list";
      } else if (grid === "3") {
        document.querySelector(`.nav-link[data-grid="3"]`)?.classList.add("active");
        visibleEl.className = "row-cols-2 row-cols-sm-2 row-cols-md-3 row g-4 product-list";
      } else if (grid === "4") {
        document.querySelector(`.nav-link[data-grid="4"]`)?.classList.add("active");
        visibleEl.className = "row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row g-4 product-list";
      } else if (grid === "5") {
        document.querySelector(`.nav-link[data-grid="5"]`)?.classList.add("active");
        visibleEl.className = "row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xxl-5 row g-4 product-list";
      }
    }

    function updateGridOnResize() {
      const width = window.innerWidth;

      if (userSelectedGrid || localStorage.getItem("selectedGrid")) return;

      if (width <= 767) {
        applyGrid("2");
      } else if (width <= 991) {
        applyGrid("3");
      } else if (width <= 1199) {
        applyGrid("4");
      } else {
        applyGrid(supportsFiveColumnGrid ? "5" : "4");
      }
    }

    gridStyleParent.querySelectorAll(".nav-link").forEach(link => {
      link.addEventListener("click", e => {
        e.preventDefault();
        userSelectedGrid = true;

        const grid = normalizeGrid(e.currentTarget.dataset.grid);
        localStorage.setItem("selectedGrid", grid); 
        applyGrid(grid);
      });
    });

    if (savedGrid) {
      const normalizedSavedGrid = normalizeGrid(savedGrid);
      if (normalizedSavedGrid !== savedGrid) {
        localStorage.setItem("selectedGrid", normalizedSavedGrid);
      }
      applyGrid(normalizedSavedGrid);
    } else {
      updateGridOnResize();
    }

    window.addEventListener("resize", updateGridOnResize);
  }

});
